import script from "./mobileTermsOfUse.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileTermsOfUse.vue?vue&type=script&setup=true&lang=js"

import "./mobileTermsOfUse.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__